export default class KeywordCommand {
    keywords: string;
    date: string;

    constructor(keywords: string, date: string) {
        this.keywords = keywords;
        this.date = date;
    }
}